import { getFrontendCustomField } from "../../../common/js/frontendCustomFields"

export default (commonBasicPlanThankYou) =>
  ({ tyPageTrialVersion } = {}) => ({
    tyPageTrialVersion: getFrontendCustomField({
      pipelineConfig,
      fieldName: "tyPageTrialVersion",
    }),

    ...commonBasicPlanThankYou({ tyPageTrialVersion }),

    init() {
      this.commonInit()
      this.store.internalTracker.trackOrderCompleted(this.store.values.purchasedBasicOffer)
    },
  })
